'use strict';

var React = require('react');
var Transition = require('react-transition-group/Transition');
var clsx = require('clsx');
var Fade = require('../Fade');
var trapFocus = require('../utils/trapFocus');
var Portal = require('../Portal');
var Close = require('../Icons/Close');
var useOpenModal = require('../utils/useOpenModal');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Transition__default = /*#__PURE__*/_interopDefaultLegacy(Transition);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var Fade__default = /*#__PURE__*/_interopDefaultLegacy(Fade);
var trapFocus__default = /*#__PURE__*/_interopDefaultLegacy(trapFocus);
var Portal__default = /*#__PURE__*/_interopDefaultLegacy(Portal);
var Close__default = /*#__PURE__*/_interopDefaultLegacy(Close);
var useOpenModal__default = /*#__PURE__*/_interopDefaultLegacy(useOpenModal);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".drawer-module_drawer-wrapper__RdprN {\n  box-shadow: -2px 0 12px 0 rgba(47, 51, 55, 0.06);\n  color: #2f3337;\n  display: flex;\n  flex: 1 0 auto;\n  flex-direction: column;\n  height: 100%;\n  overflow-y: auto;\n  position: fixed;\n  top: 0;\n  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n  transition-timing-function: ease;\n  width: 100%;\n  z-index: 1050;\n}\n.drawer-module_drawer-wrapper__RdprN.drawer-module_left__18S8m {\n  left: 0;\n  right: auto;\n  width: 315px;\n  will-change: left;\n}\n.drawer-module_drawer-wrapper__RdprN.drawer-module_right__3JGxJ {\n  left: auto;\n  right: 0;\n  width: 315px;\n  will-change: right;\n}\n.drawer-module_drawer-wrapper__RdprN.drawer-module_top__2Hzz7 {\n  bottom: auto;\n  height: auto;\n  left: 0;\n  max-height: 100%;\n  right: 0;\n  top: 0;\n  will-change: top;\n}\n.drawer-module_drawer-wrapper__RdprN.drawer-module_bottom__1tYUa {\n  bottom: 0;\n  height: auto;\n  left: 0;\n  max-height: 100%;\n  right: 0;\n  top: auto;\n  will-change: bottom;\n}\n\n.drawer-module_drawer__2Myyo {\n  width: 315px;\n}\n\n.drawer-module_drawer-header__11kyl {\n  align-items: center;\n  background-color: #fff;\n  display: flex;\n  justify-content: flex-end;\n  padding: 20px 10px 20px;\n}\n\n.drawer-module_drawer-body__2cXWf {\n  background-color: #fff;\n  height: 100%;\n  overflow: auto;\n  padding: 0px 20px;\n}\n\n.drawer-module_close__201Fg {\n  background-color: transparent;\n  color: #2d2926;\n  border: none;\n  cursor: pointer;\n  float: right;\n  font-size: 30px;\n  font-weight: 200;\n  padding: 0 5px;\n  padding: 0px;\n}\n.drawer-module_close__201Fg:focus {\n  border-radius: 50px;\n  outline: #888 dotted 1px;\n  padding: 2px;\n  margin-top: -2px;\n  margin-right: -2px;\n}\n.drawer-module_close-icon-wrapper__1zKDl {\n  display: flex;\n  padding: 10px;\n  border-radius: 50px;\n  border: 1px solid #979797;\n}\n\n.drawer-module_drawer-backdrop__3lCMT {\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 1040;\n}\n.drawer-module_drawer-backdrop__3lCMT.drawer-module_backdrop__1Az3P {\n  background-color: #323030;\n}";
var styles = {"drawer-wrapper":"drawer-module_drawer-wrapper__RdprN","left":"drawer-module_left__18S8m","right":"drawer-module_right__3JGxJ","top":"drawer-module_top__2Hzz7","bottom":"drawer-module_bottom__1tYUa","drawer":"drawer-module_drawer__2Myyo","drawer-header":"drawer-module_drawer-header__11kyl","drawer-body":"drawer-module_drawer-body__2cXWf","close":"drawer-module_close__201Fg","close-icon-wrapper":"drawer-module_close-icon-wrapper__1zKDl","drawer-backdrop":"drawer-module_drawer-backdrop__3lCMT","backdrop":"drawer-module_backdrop__1Az3P"};
styleInject(css_248z,{"insertAt":"top"});

const defaultStyles = {
    entered: { transform: `translate3d(0, 0, 0)` },
    exiting: { transform: `translate3d(0, 0, 0)` },
    unmounted: {}
};
const positions = {
    left: Object.assign({ entering: { transform: `translate3d(-50%, 0, 0)` }, exited: { transform: `translate3d(-50%, 0, 0)` } }, defaultStyles),
    right: Object.assign({ entering: { transform: `translate3d(100%, 0, 0)` }, exited: { transform: `translate3d(100%, 0, 0)` } }, defaultStyles),
    top: Object.assign({ entering: { transform: `translate3d(0, -50%, 0)` }, exited: { transform: `translate3d(0, -50%, 0)` } }, defaultStyles),
    bottom: Object.assign({ entering: { transform: `translate3d(0, 100%, 0)` }, exited: { transform: `translate3d(0, 100%, 0)` } }, defaultStyles)
};
let timeout;
const Drawer = (_a) => {
    var { backdrop = true, backdropOpacity = 0.5, backdropClassName = '', backdropDuration = 50, bodyClassName = '', children = null, className = '', close = true, duration = 100, position = 'right', onClose = null, isOpen = false, headerClassName = '', closeButtonColor = '#2D2926', closeButtonClass = '', id = '' } = _a, rest = __rest(_a, ["backdrop", "backdropOpacity", "backdropClassName", "backdropDuration", "bodyClassName", "children", "className", "close", "duration", "position", "onClose", "isOpen", "headerClassName", "closeButtonColor", "closeButtonClass", "id"]);
    const [isShowing, setIsShowing] = React.useState(isOpen);
    const closeBtnRef = React.useRef(null);
    const modalRef = React.useRef(null);
    const portalRef = React.useRef(null);
    useOpenModal__default['default']({ isOpen, setIsShowing, closeBtnRef });
    React.useEffect(() => () => clearTimeout(timeout), []);
    if (!isOpen) {
        return null;
    }
    const hideDrawer = () => {
        if (onClose) {
            timeout = setTimeout(() => {
                onClose();
            }, 250);
        }
        setIsShowing(false);
    };
    const handleKeys = (e) => {
        const key = e.keyCode || e.which;
        switch (key) {
            // Escape
            case 27: {
                hideDrawer();
                break;
            }
            // tab
            case 9: {
                trapFocus__default['default'](e, modalRef);
                break;
            }
        }
    };
    const drawerClassName = clsx__default['default'](styles['drawer-wrapper'], styles[position], className);
    return (React__default['default'].createElement(Portal__default['default'], { ref: portalRef },
        React__default['default'].createElement(React__default['default'].Fragment, null,
            React__default['default'].createElement(Transition__default['default'], Object.assign({ in: isShowing, timeout: duration, id: id }, rest), (state) => (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            React__default['default'].createElement("div", { className: drawerClassName, style: positions[position][state], role: "dialog", "aria-label": `${id} drawer`, "aria-modal": "true", ref: modalRef, onKeyDown: handleKeys },
                React__default['default'].createElement("div", { className: clsx__default['default'](styles['drawer-header'], headerClassName) }, (close || onClose) && (React__default['default'].createElement("div", { role: "button", tabIndex: 0, onClick: hideDrawer, className: styles.close, "aria-label": "Close Drawer", ref: closeBtnRef, id: `close-drawer-${id}` },
                    React__default['default'].createElement("span", { className: clsx__default['default'](styles['close-icon-wrapper'], closeButtonClass), "aria-hidden": "true" },
                        React__default['default'].createElement(Close__default['default'], { width: "10", height: "10", stroke: closeButtonColor, strokeWidth: "2" }))))),
                React__default['default'].createElement("div", { className: clsx__default['default'](styles['drawer-body'], bodyClassName) }, children)))),
            backdrop && (React__default['default'].createElement(Fade__default['default'], { className: clsx__default['default'](styles['drawer-backdrop'], isOpen && styles.backdrop, backdropClassName), onClick: hideDrawer, onKeyDown: handleKeys, duration: backdropDuration, in: isOpen && !!backdrop, opacity: backdropOpacity, "data-testid": "backdrop" })))));
};

module.exports = Drawer;
